import Vue from "vue";

const namespaced = true;

const homeProfile = JSON.parse(localStorage.getItem("hp") || "null")
const adaptationPlan = JSON.parse(localStorage.getItem("adaptationPlan") || "null")
const energy = JSON.parse(localStorage.getItem("energy") || "null")
const getUser = () => {
  if (homeProfile) {
    const { name, email } = homeProfile
    const obj = {
      name,
      email,
      home_profile: JSON.stringify(homeProfile),
    }

    if (adaptationPlan) {
      obj.adaptation_planX = adaptationPlan
    }

    if (energy) {
      obj.energy = JSON.stringify(energy)
    }

    return obj
  } else {
    return null
  }
}
const initialState = () => {
  return {
    isLogin: false,
    user: getUser(),
    energy: energy || null,
  };
};

const state = initialState();

const getters = {
  homeProfileProgress: (state) => {
    if (!state.user) return 0
    const { home_profile } = state.user


    if (home_profile) {
      const typeValCheck = (x) => {
        let condition_1 = (x && Array.isArray(x) && x.length > 0) || (x && !Array.isArray(x) & (x !== "") && x !== null) ? true : false;
        // let condition_2 = !condition_1 && x !== "" && x !== null ? true : false;
        return condition_1;
      };

      let hp = JSON.parse(home_profile)

      return ((Object.values(hp).filter((x) => typeValCheck(x)).length / Object.values(hp).length) * 100).toFixed(0)
    }

    return 0
  }
}

const mutations = {
  SET_LOGIN(state, { user, isLogin }) {
    state.isLogin = isLogin;

    if (user) state.user = user;
  },
  SET_LAST_LOGIN(state) {
    state.lastLogin = new Date();
  },
  LOAD_DEFAULT(state) {
    Object.assign(state, initialState());
  },
  UPDATE_USER(state, data) {
    // for (const key in data) {
    //   Vue.set(state.user, key, data[key])
    //   console.log(key)
    // }
    state.user = Object.assign({}, state.user, data);

    if (Object.prototype.hasOwnProperty.call(data, 'home_profile')) {
      if (!data.home_profile) {
        localStorage.removeItem('hp')
      }
    }
  },
  /* 	UPDATE_ADAPTATION_PLAN(state, data) {
    state.user = Object.assign({}, state.user, {'adaptation_plan':data})
  }, */
  UPDATE_ADAPTATION_PLAN(state, data) {
    state.user = Object.assign({}, state.user, { adaptation_planX: data });
    localStorage.setItem("adaptationPlan", JSON.stringify(data));
  },
  UPDATE_COMPETITION_ENTRY(state, data) {
    state.user = Object.assign({}, state.user, { competition_entry: data });
  },
  UPDATE_ENERGY(state, data) {
    state.energy = data;
    state.user = Object.assign({}, state.user, {
      energy: JSON.stringify(data),
    });

    localStorage.setItem("energy", JSON.stringify(data));
  },
};

const actions = {
  SET_LOGIN({ commit }, data) {
    commit("SET_LOGIN", data);
  },
  SET_LAST_LOGIN({ commit }) {
    commit("SET_LAST_LOGIN");
  },
  updateUser({ commit }, data) {
    commit("UPDATE_USER", data);
  },
  loadDefault({ commit }) {
    commit("LOAD_DEFAULT");
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
};
